const required = (name: string): string => {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Variable d'environnement manquante : ${name}`);
  }
  return value;
};

export const env = {
  get apiBaseUrl(): string {
    return required("API_BASE_URL").replace(/\/$/, "");
  },
  get sessionCookieName(): string {
    return process.env.SESSION_COOKIE_NAME || "mf_sysop_session";
  },
  get isProduction(): boolean {
    return process.env.NODE_ENV === "production";
  },
};
